export default __webpack_public_path__ + "static/media/img-senior-adult.9b4e34a0.png";